import { render, staticRenderFns } from "./weaponTable.vue?vue&type=template&id=3c6f010a&scoped=true"
import script from "./weaponTable.vue?vue&type=script&lang=js"
export * from "./weaponTable.vue?vue&type=script&lang=js"
import style0 from "./weaponTable.vue?vue&type=style&index=0&id=3c6f010a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f010a",
  null
  
)

export default component.exports